import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "flex-row" }
const _hoisted_3 = { class: "char-stat" }
const _hoisted_4 = { class: "char-stat-value" }
const _hoisted_5 = { class: "char-stat" }
const _hoisted_6 = { class: "char-stat-value" }
const _hoisted_7 = { class: "flex-row" }
const _hoisted_8 = { class: "char-stat" }
const _hoisted_9 = { class: "dark-bg char-stat-value" }
const _hoisted_10 = { class: "char-stat" }
const _hoisted_11 = { class: "dark-bg char-stat-value" }
const _hoisted_12 = { class: "flex-row" }
const _hoisted_13 = { class: "char-stat" }
const _hoisted_14 = { class: "char-stat-value" }
const _hoisted_15 = { class: "char-stat" }
const _hoisted_16 = { class: "char-stat-value" }
const _hoisted_17 = { class: "flex-row" }
const _hoisted_18 = { class: "char-stat" }
const _hoisted_19 = { class: "dark-bg char-stat-value" }
const _hoisted_20 = { class: "char-stat" }
const _hoisted_21 = { class: "dark-bg char-stat-value" }
const _hoisted_22 = { class: "flex-row" }
const _hoisted_23 = { class: "char-stat" }
const _hoisted_24 = { class: "char-stat-value" }
const _hoisted_25 = { class: "char-stat" }
const _hoisted_26 = { class: "char-stat-value" }
const _hoisted_27 = { class: "flex-row" }
const _hoisted_28 = { class: "char-stat" }
const _hoisted_29 = { class: "dark-bg char-stat-value" }
const _hoisted_30 = { class: "char-stat" }
const _hoisted_31 = { class: "dark-bg char-stat-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "char-stat-title" }, "Action Points", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.stats.ActionPoints), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "char-stat-title" }, "Melee Damage", -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stats.MeleeDamage), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Crit Chance", -1)),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.stats.CriticalChance), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Carry Weight", -1)),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.stats.CarryWeight), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "char-stat-title" }, "Sequence", -1)),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.stats.Sequence), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "char-stat-title" }, "Healing Rate", -1)),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.stats.HealingRate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Party Points", -1)),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.stats.PartyPoints), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Maximum Perks", -1)),
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.stats.MaximumPerks), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "char-stat-title" }, "SP per Level", -1)),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.stats.SkillPointsPerLevel), 1)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "char-stat-title" }, "HP per Level", -1)),
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.stats.HitPointsPerLevel), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Sight Range", -1)),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.stats.SightRange), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "dark-bg char-stat-title" }, "Weapon Range", -1)),
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.stats.WeaponRange), 1)
      ])
    ])
  ]))
}